import React from 'react'

export const IconCircledChecked = (props) => {
  return (
    <svg viewBox="0 0 80 80" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M39.9994 6.66602C21.6327 6.66602 6.66602 21.6327 6.66602 39.9994C6.66602 58.366 21.6327 73.3327 39.9994 73.3327C58.366 73.3327 73.3327 58.366 73.3327 39.9994C73.3327 21.6327 58.366 6.66602 39.9994 6.66602ZM55.9327 32.3327L37.0327 51.2327C36.566 51.6994 35.9327 51.966 35.266 51.966C34.5993 51.966 33.966 51.6994 33.4994 51.2327L24.066 41.7994C23.0993 40.8327 23.0993 39.2327 24.066 38.266C25.0327 37.2993 26.6327 37.2993 27.5993 38.266L35.266 45.9327L52.3994 28.7994C53.366 27.8327 54.966 27.8327 55.9327 28.7994C56.8994 29.766 56.8994 31.3327 55.9327 32.3327Z" />
    </svg>
  )
}
